
import { defineComponent } from "vue";

   export default defineComponent({
      props: {
         message: { type: String, required: true}
      },
      emits: ["close"],
      mounted() {
         document.getElementById("success-ok")?.focus();
      }
   });
